import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { DatePickerPopover } from 'src/components/DatePickerPopover';
import { StarsIcon } from './StarsIcon';
import { endOfDay, format, startOfDay } from 'date-fns';

import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

import store from '../../../store';
import { receiveMessage } from '../../../store/modules/chat/actions';
import { useFlags } from 'flagsmith/react';
import { customUseFlags } from 'src/hooks/customUseFlags';
import Animation from 'src/components/common/animation/index.js';

export function SummaryWithDatePicker({ chat }: any) {
  const flag = useFlags(['ia_summary']);
  const ia_summary = customUseFlags(flag.ia_summary);

  if (!ia_summary) return null;

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dateRange, setDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: null,
    endDate: null,
  });

  const handleSummarize = async (range: { startDate: Date; endDate: Date }) => {
    setLoading(true);

    const normalizeDateToRequest = {
      startDate: format(
        startOfDay(new Date(range.startDate)),
        'yyyy-MM-dd HH:mm:ss'
      ),
      endDate: format(endOfDay(new Date(range.endDate)), 'yyyy-MM-dd HH:mm:ss'),
    };

    try {
      const summary = await poliApiGatewayRequest.post(
        '/ia/messages/summarize',
        {
          contactUuid: String(chat.id),
          ...normalizeDateToRequest,
        }
      );

      const summaryData = summary.data;

      const message = {
        ...chat.last_message,
        users: chat.last_message.users,
        cuid: uuidv4(),
        updated_at: new Date().toISOString(),
        body: `*Resumido com IA - ${format(new Date(), 'dd/MM/yyyy')}*\n\n${
          summaryData.summary
        }`,
        type: 'summary',
        event: 'summarize',
        messageType: 'summary',
        uid: uuidv4(),
        id: uuidv4(),
        direction: 'sent',
        dir: null,
        chatType: 'user',
        messageId: uuidv4(),
        time: Math.floor(Date.now() / 1000).toString(),
        dtm: Math.floor(Date.now() / 1000).toString(),
      };

      store.dispatch(receiveMessage(message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        marginLeft: '12px',
      }}
    >
      <button
        onClick={() => setShow((v) => !v)}
        className="btn btn-secondary"
        style={{ padding: '5px' }}
      >
        {loading ? (
          <Animation icon="loading" size="minorLittleTiny" color="#fff" />
        ) : (
          <StarsIcon width={26} height={16} fill="#fff" />
        )}
      </button>
      {show && (
        <DatePickerPopover
          value={dateRange}
          onChange={(range) => {
            setDateRange(range);
            setShow(false);
            handleSummarize(range);
          }}
          onClear={() => setDateRange({ startDate: null, endDate: null })}
          onClose={() => setShow(false)}
        />
      )}
    </div>
  );
}
